import { render, staticRenderFns } from "./ApplicationReceived.vue?vue&type=template&id=44ff432e&scoped=true"
import script from "./ApplicationReceived.vue?vue&type=script&lang=js"
export * from "./ApplicationReceived.vue?vue&type=script&lang=js"
import style0 from "./ApplicationReceived.vue?vue&type=style&index=0&id=44ff432e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff432e",
  null
  
)

export default component.exports